import BenefitBag from "../BenefitBag";
import { Properties } from "../../../infrastructure/function-properties-types";

export default class BenefitPlan {
  [key: string]: any;

  id: string;

  name: string;

  employees: any[];

  benefitBag: BenefitBag;

  constructor({
    id = "",
    name = "",
    employees = [],
    benefitBag,
    periodicity = 12,
  }: Partial<Properties<BenefitPlan>>) {
    this.id = id || "";
    this.name = name || "";
    this.employees = employees || [];
    this.benefitBag = new BenefitBag(
      benefitBag ? { ...benefitBag, periodicity } : {}
    );
  }

  modId = (id) => new BenefitPlan({ ...this, id });

  modName = (name) => new BenefitPlan({ ...this, name });

  modEmployees = (employees) => new BenefitPlan({ ...this, employees });

  modBenefitBagPeriodicity(periodicity) {
    return new BenefitPlan({
      ...this,
      periodicity,
    });
  }

  modBenefitBagAvailabilityDate({ date }) {
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        date,
      },
    });
  }

  modBenefitBagLimitAmount(amount) {
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        amount,
      },
    });
  }

  modBenefitBagCanBeAccumulated() {
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        canBeAccumulated: !this.benefitBag.canBeAccumulated,
      },
    });
  }

  modBenefitOnCardDeliveryOnPeriodEnd() {
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        shouldBeDeliveredOnCardOnPeriodEnd:
          !this.benefitBag.shouldBeDeliveredOnCardOnPeriodEnd,
      },
    });
  }

  modBenefitBagBenefitTypeInclusion({ name }) {
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        availableFor: {
          ...this.benefitBag.availableFor,
          [name]: this.benefitBag.availableFor[name].modIsActive(),
        },
      },
    });
  }

  modBenefitBagBenefitTypeAvailability({ names }) {
    let result = {};
    names.forEach((name) => {
      result = {
        ...result,
        [name]: this.benefitBag.availableFor[name],
      };
    });
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        availableFor: result,
      },
    });
  }

  modifyBenefitBagName(bagName) {
    return new BenefitPlan({
      ...this,
      periodicity: this.benefitBag.periodicity,
      benefitBag: {
        ...this.benefitBag,
        name: bagName,
      },
    });
  }
}
